jQuery( function( $ ) {
	$( 'body.single-product .summary-inner-wrapper li.variable-item' ).on( 'click', function() {
		// Get size slug for that variation id, for example bia-0
		const $variationSlug = $( this ).data( 'value' );

		const $targetElement = $( '.b2b-variation-id[data-id=' + $variationSlug + ']' );

		if ( $targetElement.length ) {
			const $targetPrice = $targetElement.data( 'variation-price' );

			$( '.custom-price-html bdi' ).html( $targetPrice + ' <span class="woocommerce-Price-currencySymbol">kr</span>' );

			$( '.from-string' ).hide();
		}
	} );
} );
